<template>
  <div>
    <BTableCommon
      type="munmeh-logs"
      :list="list"
      :pagination="pagination"
      :items-per-page-options="[5]"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @action:view="onJumpToIndicator"
      @change:pagination="onChangePagination"
    />
  </div>
</template>

<script>
import BTableCommon from '@/components/tables/BTableCommon.vue'
import { LkMunMehAdapter } from '@/views/LKMunMeh/store/LkMunMehAdapter'

const INDICATORS_PER_PAGE = 5

const DEFAULT_PARAMS = {
  page: 1,
  per_page: INDICATORS_PER_PAGE,
  count: 0,
}

export default {
  name: 'LKMunMehLogsTable',
  components: { BTableCommon },
  props: {
    form: {
      type: Object,
      default: null,
    },
    indicatorIdsWithLogs: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isLoadingAsyncData: false,
    list: [],
    pagination: { ...DEFAULT_PARAMS },
    indicatorProps: {},
  }),
  computed: {
    indicatorIds() {
      const start = (this.pagination.page - 1) * INDICATORS_PER_PAGE
      const end = start + INDICATORS_PER_PAGE
      return this.indicatorIdsWithLogs.slice(start, end)
    },
  },
  watch: {
    form: {
      handler(v) {
        if (!v) return
        v?.data?.forEach((level, idx) => this.onBuildProps(level, `${idx + 1}.`))
      },
      immediate: true,
    },
  },
  methods: {
    asyncData() {
      this.onGetData()
    },
    onChangePagination(options) {
      this.pagination.page = options.page || DEFAULT_PARAMS.page
      this.pagination.per_page = options.per_page || DEFAULT_PARAMS.per_page

      return this.onGetData()
    },
    async onGetData() {
      if (!this.form.id || this.form.id < 0) {
        return
      }
      this.isLoading = true
      const adapter = new LkMunMehAdapter()

      try {
        const result = await adapter.api.getFormActionsSortedHistoryList(
          this.form.id,
          {
            indicator_ids: this.indicatorIds,
          },
          // params
        )
        this.list = this.insertIndicatorNames(result.data)

        // this.pagination = { ...this.pagination, ...result.meta }
        this.pagination.count = this.indicatorIdsWithLogs.length
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    onJumpToIndicator(v) {
      this.$emit('action:view', v)
    },
    onBuildProps(level, prefix) {
      if (!this.indicatorProps[level.id]) {
        this.indicatorProps[level.id] = [prefix, level.name].join(' ')
      }

      level.items?.forEach((child, idx) => this.onBuildProps(child, `${prefix}${idx + 1}.`))
    },
    insertIndicatorNames(arr) {
      return arr.map((el) => ({
        ...el,
        indicatorName: this.indicatorProps[el.id],
      }))
    },
  },
}
</script>
